import * as Sentry from '@sentry/browser';

import {
  error as commonError,
  finleyAssert,
} from '@finley-technologies/common';
import { typeguards } from '@finley-technologies/finley-types';

export const parseAssignmentSummaryPreview = (
  assignmentSummaryPreview: string,
  isInitialPreview: boolean,
) => {
  try {
    // @jendevelops TODO: validate data coming from backend

    const parsedAssignmentSummaryPreview = JSON.parse(assignmentSummaryPreview);

    if (isInitialPreview) {
      finleyAssert(
        parsedAssignmentSummaryPreview,
        `Expected initial summary preview to exist`,
      );
    }

    return parsedAssignmentSummaryPreview;
  } catch (err) {
    // @jendevelops TODO: handle parsing error
    Sentry.captureException(JSON.stringify(err));
    throw err;
  }
};

export const parseAggregatedAssignmentSummaryPreview = (
  assignmentSummaryPreview: string,
  receivableResponseTapePreviewJobId: string,
) => {
  try {
    const parsedAssignmentSummaryPreview = JSON.parse(assignmentSummaryPreview);

    finleyAssert(
      typeguards.assignment.isAggregatedAssignmentSummaryPreviewConfig(
        parsedAssignmentSummaryPreview,
      ),
      new commonError.TypeError({
        resourceType: 'AggregatedAssignmentSummaryPreview',
        typeguardName: 'isAggregatedAssignmentSummaryPreviewConfig',
        metadata: {
          logMeta: {
            receivableResponseTapePreviewJobId,
            parsedAssignmentSummaryPreview,
          },
        },
      }),
    );

    return parsedAssignmentSummaryPreview;
  } catch (err) {
    Sentry.captureException(JSON.stringify(err));
    throw err;
  }
};
